import { render, staticRenderFns } from "./BottomPopup.vue?vue&type=template&id=343f9edc&scoped=true"
import script from "./BottomPopup.vue?vue&type=script&lang=js"
export * from "./BottomPopup.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=343f9edc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343f9edc",
  null
  
)

export default component.exports